// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import CollectRouteQRScanning from 'components/organisms/CollectRouteQRScanning';
import CollectRouteQRScanHeader from 'components/organisms/CollectRouteQRScanHeader';
import CollectRouteTemplate from 'components/templates/CollectRouteTemplate';
import { Path } from 'routes';
import styles from './CollectRouteQRScan.module.scss';
import { useLocation, useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { getApiPath, objectFetch } from 'util/commons';
import { useState } from 'react';

const CollectRouteQRScan = () => {
  const { t } = useTranslation();
  const { routeId, siteId } = useParams<{ routeId: string; siteId: string }>();
  const { state } = useLocation();
  const [hasCollectedSuccess, setHasCollectedSuccess] = useState(false);
  const history = useHistory();

  return (
    <CollectRouteTemplate
      h1={t('collects.title')}
      showViewModeSwitch={false}
      leftComponent={<CollectRouteQRScanHeader siteId={siteId} />}
      prevFunction={() => {
        history.push(
          `${getApiPath(Path.routeSiteSelection, {
            routeId: objectFetch(state, 'routeId') || routeId,
          })}${window.location.search}`,
          {
            refreshSites: hasCollectedSuccess || objectFetch(state, 'routeId'),
          }
        );
      }}
      classNames={{
        actions: styles.actionBar,
      }}
    >
      <CollectRouteQRScanning
        routeId={routeId}
        siteId={siteId}
        setHasCollectedSuccess={setHasCollectedSuccess}
      />
    </CollectRouteTemplate>
  );
};

export default CollectRouteQRScan;
